import React, { useEffect, useState } from 'react'
import './Network.css'

const NetWork = (props) => {
    const [showWarning, setShowWarning] = useState(false)

    useEffect(() => {
        const updateNetworkStatus = () => {
            const isOffline = !navigator.onLine

            const connection =
                navigator.connection || navigator.mozConnection || navigator.webkitConnection

            const isSlow =
                connection && ['slow-2g', '2g', '3g', '4g'].includes(connection.effectiveType)

            setShowWarning(isOffline || isSlow)
        }

        // Initial check
        updateNetworkStatus()

        // Online / Offline listeners
        window.addEventListener('online', updateNetworkStatus)
        window.addEventListener('offline', updateNetworkStatus)

        // Network speed change listener (if supported)
        navigator.connection?.addEventListener('change', updateNetworkStatus)

        return () => {
            window.removeEventListener('online', updateNetworkStatus)
            window.removeEventListener('offline', updateNetworkStatus)
            navigator.connection?.removeEventListener('change', updateNetworkStatus)
        }
    }, [])

    if (!showWarning) return null
    return (
        <div className="netWorkConnect">
            Tip: Occasionally Refresh Your Page To Ensure Fastest Connectivity
        </div>
    )
}

export default NetWork
